import { useUnreadCounts as useGenericUnreadCounts } from '../../../services/messagerie/useUnreadCounts';

export type { MessageChannel, UnreadCounts } from '../../../services/messagerie/useUnreadCounts';

// Compteurs de non-lus cote ACHETEUR MS. Rebranche sur le hook generique partage
// (module /subsequents, role acheteur) : plus de duplication de la logique effect + markRead.
export const useUnreadCounts = (operationId?: number | string) =>
  useGenericUnreadCounts('/subsequents', 'acheteur', operationId);
